<script setup lang="ts">
import { ref } from 'vue';
import { useStudyGroupsStore } from '@/stores/studyGroups';
import { Table } from '@/components/common';
import moment from 'moment';
import StudyGroupDialog from './StudyGroupDialog.vue';
import { StudyGroupModel } from '@/models/groups';
import { ButtonType, CustomButton } from '@/components';

const emit = defineEmits(['openCloseCreateGroupDialog']);

const groupStore = useStudyGroupsStore();
groupStore.getStudyGroups();

const formattedDate = (date: Date) => {
  return moment(date).format('DD MMM YYYY hh:mm A');
};

const openGroupDialog = ref<boolean>(false);

const rowClick = (data: StudyGroupModel) => {
  groupStore.updateGroup(data);
  openCloseGroupDialog();
};

const openCloseGroupDialog = (reloadGroups?: boolean) => {
  openGroupDialog.value = !openGroupDialog.value;
  if (reloadGroups === true) {
    groupStore.getStudyGroups();
  }
};
</script>

<template>
  <Table :columns="groupStore.tableColumns"
    :data-list="groupStore.studyGroups"
    :loading-state="groupStore.isStudyGroupsLoading.isLoading"
    :rows="10"
    @onRowClick="rowClick"
    presort="createdAt">
    <template #bodyContent="{ data, col }">
      <div>
        {{
          col.key === "createdAt" || col.key === "updatedAt"
            ? formattedDate(data[col.key])
            : data[col.key]
        }}
      </div>
    </template>
    <template #emptyContent>
      <div class="empty-content-container">
        <div class="empty-content">
          <FontAwesomeIcon :icon="[`fal`, 'people-group']" class="icon" />
          <h3 class="no-entries-label">No groups created yet</h3>
          <div class="create-context-wrapper">
            <div class="new-entry-text">To create a group click on</div>
            <CustomButton text="Create group"
                :type="ButtonType.POSITIVE"
                :marginLeft="16"
                @onClick="emit('openCloseCreateGroupDialog')" />
          </div>
        </div>
      </div>
    </template>
  </Table>
  <StudyGroupDialog :visible="openGroupDialog"
    v-if="openGroupDialog"
    @onClose="openCloseGroupDialog"/>
</template>

<style scoped lang="scss">
:deep(.p-row-even) {
  cursor: pointer;
  &:hover {
    background-color: #f2f2f2;
  }
}
:deep(.p-row-odd) {
  cursor: pointer;
  &:hover {
    background-color: #f2f2f2;
  }
}
.create-context-wrapper {
  display: flex;
  align-items: center;
  margin: 16px 0;
}
.empty-content-container {
  .empty-content {
    .icon {
      font-size: 100px;
      margin: 16px 0px;
    }
  }
}
</style>
